import { isInertiaUrl } from 'shared/javascripts/util/inertia_paths'

up.compiler('[data-keep-return-path]', (element) => {
  const href = element.getAttribute('href')

  function updateHref() {
    if (up.layer.isOverlay()) return

    const currentPath = up.util.parseURL(up.history.location).pathname
    const glue = href?.includes('?') ? '&' : '?'
    const target = `${href}${glue}return_to=${currentPath}`

    element.setAttribute('up-href', target)
    // Unpoly leaves links into the Inertia app to the browser, which only follows `href`.
    if (isInertiaUrl(new URL(target, window.location.href))) {
      element.setAttribute('href', target)
    }
  }

  up.on('up:fragment:inserted', updateHref)

  return () => {
    up.off('up:fragment:inserted', updateHref)
  }
})
